import { FiscalUsageType } from '../models/request-and-responses/rest-api/enums/fiscalUsageType';

interface IFiscalUsageTypeObject {
    id: FiscalUsageType;
    label: string;
}
export const FiscalUsageTypeObjects: IFiscalUsageTypeObject[] = [
    {
        id: FiscalUsageType.Civil,
        label: 'Civile'
    },
    {
        id: FiscalUsageType.Industrial,
        label: 'Industriale'
    },
    {
        id: FiscalUsageType.EnergyProduction,
        label: 'Produzione energia elettrica'
    },
    {
        id: FiscalUsageType.AutoEnergyProduction,
        label: 'Autoproduzione energia elettrica'
    },
    {
        id: FiscalUsageType.ArmedForces,
        label: 'Forze armate nazionali'
    },
    {
        id: FiscalUsageType.ConstructionUsage,
        label: 'Uso cantiere, motori fissi, coltivazione idrocarburi'
    },
    {
        id: FiscalUsageType.AutoTraction,
        label: 'Autotrazione'
    }
];



// WEBPACK FOOTER //
// ./src/app/helpers/FiscalUsageTypeObjects.ts